export const pageNameFromPathname = (pathname: string): string => {
  return pathname.split('/').filter(Boolean).join('_').replace(/-/g, '_')
}
